const questions = [
    {
      "id": 1,
      "question": "いなかに帰ると,幼いころのことが[　ア　]思い出されて,[　イ　]なつかしい。",
      "choices": {
        "wordA": ["1.このまま　", "2.さぞ　", "3.しみじみ　", "4.あたかも"],
        "wordB": ["1.あまり　", "2.とても　", "3.すっかり　", "4.ほとんど"]
      },
      "answer": {
        "answerA": 3,
        "answerB": 2
      }
    },
    {
      "id": 2,
      "question": "ひらきかけた梅の[　ア　]に,春の訪れを[　イ　]今日このごろです。",
      "choices": {
        "wordA": ["1.実　","2.葉　", "3.つぼみ　", "4.枝"],
        "wordB": ["1.招く　","2.さそう　", "3.うかがう　", "4.感じる"]
      },
      "answer": {
        "answerA": 3,
        "answerB": 4
      }
    }, 
  {
      "id": 3,
      "question": "いままで[　ア　]いた山の頂が,あっという間に霧に[　イ　]しまった。",
      "choices": {
        "wordA": ["1.かくれて　","2.曇って　", "3.ふぶいて　", "4.晴れて"],
        "wordB": ["1.つつまれて　","2.流されて　", "3.うずもれて　", "4.降られて"]
      },
      "answer": {
        "answerA": 4,
        "answerB": 1
      }
    }, 
  {
      "id": 4,
      "question": "ことしは冬の訪れが[　ア　]という[　イ　]どおりに,もう各地から初雪のたよりが届いています。",
      "choices": {
        "wordA": ["1.遅い　","2.早い　", "3.きびしい　", "4.速い"],
        "wordB": ["1.予知　","2.警告　", "3.予報　", "4.予防"]
      },
      "answer": {
        "answerA": 2,
        "answerB": 3
      }
    },
  {
      "id": 5,
      "question": "難問にぶつかって困っていたが,ともだちと話している[　ア　]その解決法が[　イ　]。",
      "choices": {
        "wordA": ["1.うちに　","2.ままに　", "3.ように　", "4.までに"],
        "wordB": ["1.みいだした　","2.なくなった　", "3.ひらめいた　", "4.はじまった"]
      },
      "answer": {
        "answerA": 1,
        "answerB": 3
      }
    }, 
  {
      "id": 6,
      "question": "暑い日が続きますが,[　ア　]お変りありませんか。私は暑さにもまけず毎日[　イ　]に過ごしています。",
      "choices": {
        "wordA": ["1.当分　","2.しばらく　", "3.前から　", "4.その後"],
        "wordB": ["1.弱気　","2.元気　", "3.病気　", "4.平気"]
      },
      "answer": {
        "answerA": 4,
        "answerB": 2
      }
    },
  
  {
      "id": 7,
      "question": "はち植え植物にとって[　ア　]を十分にやることはたいせつだ。[　イ　],根を腐らせるほどやりすぎてはいけない。",
      "choices": {
        "wordA": ["1.水　","2.日光　", "3.土　", "4.風"],
        "wordB": ["1.しかし　","2.そのうえ　", "3.あるいは　", "4.それから"]
      },
      "answer": {
        "answerA": 1,
        "answerB": 1
      }
    },
  {
      "id": 8,
      "question": "台風が[　ア　]した地方に大きな被害がでているということが,テレビで[　イ　]されました。",
      "choices": {
        "wordA": ["1.来訪　","2.通過　", "3.通行　", "4.訪問"],
        "wordB": ["1.上映　","2.演出　", "3.報道　", "4.報告"]
      },
      "answer": {
        "answerA": 2,
        "answerB": 3
      }
    },
  {
      "id": 9,
      "question": "今夜じゅうには[　ア　]できそうにないと,気ばかり[　イ　]いるうちに,夜中の12時を過ぎてしまった。",
      "choices": {
        "wordA": ["1.よほど　", "2.ついに　", "3.まさか　", "4.とても"],
        "wordB": ["1.あきらめて　","2.あせって　", "3.落ちついて　", "4.進んで"]
      },
      "answer": {
        "answerA": 4,
        "answerB": 2
      }
    },
  {
      "id": 10,
      "question": "この町は[　ア　]有名な織物の産地[　イ　],街のあちこちから織機の音がきこえてくる。",
      "choices": {
        "wordA": ["1.さすが　","2.よくも　", "3.いかに　", "4.きっと"],
        "wordB": ["1.であるが　","2.なのに　", "3.だけあって　", "4.といっても"]
      },
      "answer": {
        "answerA": 1,
        "answerB": 3
      }
    },
  {
      "id": 11,
      "question": "その会議は2つの意見が[　ア　]して,お互いがゆずらないため,[　イ　]が出ないままにおわってしまった。",
      "choices": {
        "wordA": ["1.対立　","2.対話　", "3.対応　", "4.反対"],
        "wordB": ["1.結果　","2.一致　", "3.結論　", "4.同意"]
      },
      "answer": {
        "answerA": 1,
        "answerB": 3
      }
    },
  {
      "id": 12,
      "question": "日程の都合で,明日の試合は[　ア　]雨が降っ[　イ　]行われる予定です。",
      "choices": {
        "wordA": ["1.よもや　","2.たとえ　", "3.いつも　", "4.どうか"],
        "wordB": ["1.たら　","2.ても　", "3.たとき　", "4.たのに"]
      },
      "answer": {
        "answerA": 2,
        "answerB": 2
      }
    },
  
  {
      "id": 13,
      "question": "初めての仕事なので何となく[　ア　]がもてなかったが,やってみたら[　イ　]たやすくできた。",
      "choices": {
        "wordA": ["1.過信　", "2.安心　", "3.心配　", "4.自信"],
        "wordB": ["1.前より　", "2.ついに　", "3.急に　", "4.案外"]
      },
      "answer": {
        "answerA": 4,
        "answerB": 4
      }
    },
  {
      "id": 14,
      "question": "「人のうわさも七十五日」というのは,[　ア　]のうわさはそう長く続かないことをいった[　イ　]である。",
      "choices": {
        "wordA": ["1.世界　", "2.世間　", "3.社会　", "4.家庭"],
        "wordB": ["1.いましめ　", "2.警句　", "3.注意　","4.ことわざ"]
      },
      "answer": {
        "answerA": 2,
        "answerB": 4
      }
    },
  {
      "id": 15,
      "question": "この仕事をかれにまかせることには[　ア　][　イ　]もあったが,かれはりっぱにやりとげてくれた。",
      "choices": {
        "wordA": ["1.よほど　","2.まったく　","3.やや　","4.えてして"],
        "wordB": ["1.不安　","2.怒り　","3.あきらめ　", "4.不信"]
      },
      "answer": {
        "answerA": 3,
        "answerB": 1
      }
    },
  
  {
      "id": 16,
      "question": "自分のことは[　ア　],他人を[　イ　]するのはよいことではない。",
      "choices": {
        "wordA": ["1.水に流して　","2.たなにあげて　","3.ふたをして　","4.まつりあげて"], 
        "wordB": ["1.納得　","2.理解　","3.非難　","4.賞賛"]
      },
      "answer": {
        "answerA": 2,
        "answerB": 3
      }
    },
  
  {
      "id": 17,
      "question": "きょうは[　ア　]少し[　イ　]お金の持ち合わせがありません。",
      "choices": {
        "wordA": ["1.わずか　","2.ほんの　","3.やや　","4.ぜんぜん"],
        "wordB": ["1.だけ　","2.さえ　","3.のみ　","4.しか"]
      },
      "answer": {
        "answerA": 2,
        "answerB": 4
      }
    },
  
  {
      "id": 18,
      "question": "観測を再開しようという声が,多くの科学者から[　ア　]いますが,結論のでるまでにはもう少し[　イ　]がかかります。",
      "choices": {
        "wordA": ["1.あがって　","2.のぼって　","3.うたわれて　","4.求められて"],
        "wordB": ["1.間隔　","2.時間　","3.時刻　","4.空間"]
      },
      "answer": {
        "answerA": 1,
        "answerB": 2
      }
    },
  
  {
      "id": 19,
      "question": "かれが,何か[　ア　]しゃべり始めたので,みんなつられて[　イ　]を乗りだした。",
      "choices": {
        "wordA": ["1.しさいありげに　","2.しどろもどろに　","3.さりげなく　","4.ぬかりなく"],
        "wordB": ["1.顔　", "2.耳　","3.車　","4.身"]
      },
      "answer": {
        "answerA": 1,
        "answerB": 4
      }
    },
  
  {
      "id": 20,
      "question": "そのバスは[　ア　]とても混んでいた[　イ　],つかれていたのに降りるまで座れなかった。",
      "choices": {
        "wordA": ["1.さいわい　","2.ちょうど　","3.あいにく　","4.うれしいことに"],
        "wordB": ["1.ので　","2.けれど　","3.らしく　","4.わけで"]
      },
      "answer": {
        "answerA": 3,
        "answerB": 1
      }
    },
  
  {
      "id": 21,
      "question": "火山の[　ア　]は,その壮大さゆえに昔から人類の[　イ　]であった。",
      "choices": {
        "wordA": ["1.流出　","2.排出　","3.噴火　","4.点火"],
        "wordB": ["1.願望　","2.尊敬　","3.驚異　","4.悲劇"]
      },
      "answer": {
        "answerA": 3,
        "answerB": 3
      }
    },
  
  {
      "id": 22,
      "question": "事実をしるす文章は,その[　ア　]を相手にわかるように[　イ　]に表現することがたいせつである。",
      "choices": {
        "wordA": ["1.理由　","2.原因　","3.結果　","4.事柄"],
        "wordB": ["1.主観的　","2.捕象的　","3.客観的　","4.感情的"]
      },
      "answer": {
        "answerA": 4,
        "answerB": 3
      }
    },
  
  {
      "id": 23,
      "question": "コンピュータは,大量のデータをきわめて迅速[　ア　]正確に[　イ　]することができる。",
      "choices": {
        "wordA": ["1.やら　","2.でも　","3.より　","4.かつ"],
        "wordB": ["1.処置　","2.処理　","3.解決　","4.解答"]
      },
      "answer": {
        "answerA": 4,
        "answerB": 2
      }
    },
  
  {
      "id": 24,
      "question": "地球上の[　ア　]は,それぞれ異なった[　イ　]をもって生活している。",
      "choices": {
        "wordA": ["1.人類　","2.民族　","3.民衆　","4.人間"],
        "wordB": ["1.文化　","2.科学　","3.教育　","4.芸術"]
      },
      "answer": {
        "answerA": 2,
        "answerB": 1
    }
  }
  ];

  export default questions;